/**
 * Feature-local type stubs for the photo-moderation reviewer tool.
 *
 * API contract types (queue items, review decisions, etc.) are defined in
 * GUE-3867 and will live in @owner/olympus-client once generated. This file
 * holds only the shell types the scaffold needs today.
 */

/** Single-source-of-truth Unleash flag name for the photo reviewer tool. */
export const GUEST_PHOTO_REVIEWER_FLAG = 'hermes.guest-photo-reviewer'

/** Placeholder — replaced by the contract types in GUE-3867. */
export type PhotoModerationStatus = 'pending' | 'approved' | 'rejected'
